import React, { useState } from 'react';
import { UncontrolledCarousel } from 'reactstrap';
import './SlideShow.css';
import { useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASEURL;

function SlideShow ({slides, setSlides}){
// class SlideShow extends React.Component {
const[slidesCount, setSlidesCount] = useState(slides.length);
useEffect(() => {
    // console.log('app mounted');
    // console.log(slidesCount)
  }, [slides]);

  useEffect(() => {
    findSlides();
  }, []);

  const findSlides = () => {
  axios.get(apiUrl + "/api/Header/GetCarouselImages", {
  })
  .then((response) => {
    // console.log("response data", response.data);
    setSlides(response.data); // Make sure response.data is an array
    setSlidesCount(slides.length)
  })
  .catch((error) => {
    console.log(error);
  });
  };
//     componentDidMount() {
//         console.log('app mounted');
        
//         fetch(apiUrl + "/api/Header/GetCarouselImages")
//             .then this.setState(carouselList: response.data)
//             // .then(response.data => data.json())
//             // .then(response.data => this.setState({ carouselList: data }, () => console.log(data)));
// }

//     render() {
    
        // var slideshowList = this.state.carouselList;
       
        
        // if (slides == null) {
        //     console.log("NULL");
        //     return (
        //         <div>
        //             <h1>{/*ERROR*/}</h1>
        //         </div>
        //     );
        // }
        // else {
            let slideshowFinal = new Array(slides.length);
            for (let i = 0; i < slides.length; i++) {
                slideshowFinal[i] = { src: "data:image/png;base64," + slides[i].newsImage, key: i + 1 };
            }
            return (
                <div  id="bootstrap-overrides">
                    <UncontrolledCarousel items={slideshowFinal} />
                    <style>
                    {`.carousel-item > img {
                      max-width: 100%;
                      height: auto;
                    }`}
                  </style>

                </div>
            );
        // }
    };
export default SlideShow;